module.exports = __webpack_public_path__ + "img/12-1_05.802c5d53.jpg";